/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { FragmentsDeliveryGetDeliveryStatusQueryResponse, FragmentsDeliveryGetDeliveryStatusPathParams, FragmentsDeliveryGetDeliveryStatus401, FragmentsDeliveryGetDeliveryStatus403, FragmentsDeliveryGetDeliveryStatus404 } from "../models/FragmentsDeliveryGetDeliveryStatus";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { fragmentsDeliveryGetDeliveryStatus } from "../axios/fragmentsDeliveryGetDeliveryStatus";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const fragmentsDeliveryGetDeliveryStatusQueryKey = (fragmentId: FragmentsDeliveryGetDeliveryStatusPathParams["fragmentId"]) => ["api-v2", { url: '/fragments-delivery/v1/delivery/:fragmentId', params: {fragmentId:fragmentId} }] as const

export type FragmentsDeliveryGetDeliveryStatusQueryKey = ReturnType<typeof fragmentsDeliveryGetDeliveryStatusQueryKey>

export function fragmentsDeliveryGetDeliveryStatusQueryOptions(fragmentId: FragmentsDeliveryGetDeliveryStatusPathParams["fragmentId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = fragmentsDeliveryGetDeliveryStatusQueryKey(fragmentId)
        return queryOptions<FragmentsDeliveryGetDeliveryStatusQueryResponse, ResponseErrorConfig<FragmentsDeliveryGetDeliveryStatus401 | FragmentsDeliveryGetDeliveryStatus403 | FragmentsDeliveryGetDeliveryStatus404>, FragmentsDeliveryGetDeliveryStatusQueryResponse, typeof queryKey>({
         enabled: !!(fragmentId),
         queryKey,
         queryFn: async ({ signal }) => {
            return fragmentsDeliveryGetDeliveryStatus(fragmentId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Retrieves the current delivery status and progress for a fragment
 * @summary Get delivery status for a fragment
 * {@link /fragments-delivery/v1/delivery/:fragmentId}
 */
export function useFragmentsDeliveryGetDeliveryStatus<TData = FragmentsDeliveryGetDeliveryStatusQueryResponse, TQueryData = FragmentsDeliveryGetDeliveryStatusQueryResponse, TQueryKey extends QueryKey = FragmentsDeliveryGetDeliveryStatusQueryKey>(fragmentId: FragmentsDeliveryGetDeliveryStatusPathParams["fragmentId"], options: 
{
  query?: Partial<QueryObserverOptions<FragmentsDeliveryGetDeliveryStatusQueryResponse, ResponseErrorConfig<FragmentsDeliveryGetDeliveryStatus401 | FragmentsDeliveryGetDeliveryStatus403 | FragmentsDeliveryGetDeliveryStatus404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? fragmentsDeliveryGetDeliveryStatusQueryKey(fragmentId)
         

         const query = useQuery({
          ...fragmentsDeliveryGetDeliveryStatusQueryOptions(fragmentId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<FragmentsDeliveryGetDeliveryStatus401 | FragmentsDeliveryGetDeliveryStatus403 | FragmentsDeliveryGetDeliveryStatus404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}